import microsoftLogo from '@atom/components/common/svgIcons/microsoftLogo.svg';
import oktaLogo from '@atom/components/common/svgIcons/oktaLogo.svg';

export type SsoProvider = {
  label: string;
  logo: string;
};

export const ssoConnectionConfig: Record<string, SsoProvider> = {
  'azure-ad': {
    label: 'Microsoft',
    logo: microsoftLogo,
  },
  okta: {
    label: 'Okta',
    logo: oktaLogo,
  },
};
